import { useEffect } from 'react';
import { createPortal } from 'react-dom';
export const Portal = ({ children, target }) => {
    const body = target || document.querySelector('body');
    const portal = document.createElement('div');
    const el = document.createElement('div');
    useEffect(() => {
        if (body) {
            body.appendChild(portal);
            portal.appendChild(el);
        }
        return () => {
            if (body) {
                body.removeChild(portal);
            }
        };
    }, [body, el, portal]);
    return createPortal(children, el);
};
//# sourceMappingURL=Portal.js.map